import axios from 'axios';

const functionsApi = axios.create({
  baseURL: 'https://us-central1-firebase-hiitandtabata.cloudfunctions.net'
  // baseURL: 'http://localhost:5001/firebase-hiitandtabata/us-central1'
  // baseURL: 'http://localhost:5001/hiitandtabata-dev/us-central1'
    // baseURL: 'https://us-central1-hiitandtabata-dev.cloudfunctions.net'
})

functionsApi.interceptors.request.use(config => {
  if (config.method === 'POST' || config.method === 'PATCH' || config.method === 'PUT')
    config.headers['Content-Type'] = 'application/json;charset=utf-8';

  const authToken = localStorage.getItem('AuthToken');
  if (authToken) config.headers.Authorization = authToken;

  return config;
});

export default functionsApi;